import { Base64Image, Url } from '../models/common';
import { Nullish } from './typescript';

export function isImage(url: Nullish<Url>): boolean {
  if (!url) return false;
  return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

export function preloadImage(url: Url): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', () => reject());
    image.src = url;
  });
}

export function base64ImageAsUrl(data: Nullish<Base64Image>): Url | null {
  if (data) {
    return `data:image/jpg;base64,${data}`;
  } else {
    return null;
  }
}